export class CharacterCounter {
    /**
     * @type {HTMLTextAreaElement}
     * @private
     */
    _textarea;

    /**
     * @type {HTMLElement}
     * @private
     */
    _wrapper;

    /**
     * @type {number}
     * @private
     */
    _maxLength;

    get textarea() {
        return this._textarea;
    }

    set textarea(value) {
        this._textarea = value;
    }

    get wrapper() {
        return this._wrapper;
    }

    set wrapper(value) {
        this._wrapper = value;
    }

    get maxLength() {
        return this._maxLength;
    }

    set maxLength(value) {
        this._maxLength = value;
    }

    constructor(textarea) {
        this.textarea = textarea;
        this.wrapper = textarea.closest('.wpcf7-form-control-wrap');
        this.maxLength = parseInt(textarea.getAttribute('maxlength')) || 500;

        if (!this.wrapper) return;

        this.init();
    }

    init() {
        // Ajouter la classe pour afficher le compteur
        this.wrapper.classList.add('has-counter');

        // Mettre à jour le compteur
        this.updateCounter();

        // Écouter les changements
        this.textarea.addEventListener('input', () => this.updateCounter());
        this.textarea.addEventListener('keyup', () => this.updateCounter());
    }

    updateCounter() {
        const currentLength = this.textarea.value.length;
        const count = `${currentLength}/${this.maxLength}`;
        
        this.wrapper.setAttribute('data-count', count);
    }
}
